import { DecisionQuestion } from "@/types/prompt-blueprint";

export const DEFAULT_MODEL_NAMES = {
  openai: "gpt-5.4",
  "openai.azure": "gpt-5.4",
  anthropic: "claude-sonnet-4-6",
  "amazon.bedrock": "us.anthropic.claude-sonnet-4-20250514-v1:0",
  google: "gemini-2.5-flash",
  mistral: "mistral-large-latest",
  cohere: "command-a-03-2025",
  openrouter: "openai/gpt-5.4",
  vertexai: "gemini-2.5-flash",
};

export const DECISIONS_API = "decisions";

export const DEFAULT_DECISION_QUESTIONS: DecisionQuestion[] = [
  {
    name: "matches",
    type: "binary",
    instructions: "Does the input match what you are looking for?",
  },
];

export const OPENAI_DEFAULT_MODELS_BY_API: Record<string, string> = {
  responses: "gpt-5.4",
  "chat-completions": "gpt-5.4",
  images: "gpt-image-1.5",
  [DECISIONS_API]: "gpt-6-luna",
};

export const OPENROUTER_DEFAULT_MODELS_BY_API: Record<string, string> = {
  chat: "openai/gpt-5.4",
  images: "openai/gpt-image-2",
  video: "google/veo-3.1",
  speech: "google/gemini-3.1-flash-tts-preview",
  [DECISIONS_API]: "openai/gpt-6-luna-decisions",
};

export const HUGGINGFACE_PROVIDER = "huggingface";
export const VERTEXAI_PROVIDER = "vertexai";
